var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_409"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    d: "M19.5915,18.7404c-.1644.5475-.4317,1.0586-.7876,1.506-.6607.9648-1.5536,1.7476-2.5966,2.2763-.7222.3796-1.5095.6195-2.3206.7072-1.0888.1446-2.196.0514-3.2452-.2734-.7136-.2393-1.3792-.6032-1.9657-1.0748-1.123-.9271-1.9523-2.1607-2.3868-3.5507-.027-.0799-.1268-.1813-.0387-.2301.1252-.0692.1415.0906.194.1614,1.0486,1.4184,2.5024,2.4858,4.1698,3.0614,1.068.3634,2.2026.4887,3.3241.3671,1.2409-.1228,2.4342-.5418,3.4794-1.2219.6957-.4382,1.3332-.9625,1.8975-1.5605.0641-.0677.1125-.167.2765-.169",
    fill: "#7c9e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    d: "M16.2781,20.417c-.6108.234-1.2511.3823-1.9026.4409-1.0639.1115-2.1391-.028-3.1393-.4073-1.1988-.446-2.2517-1.2133-3.0436-2.2178-.5702-.6577-.9994-1.4253-1.2611-2.2554-.3062-.9707-.3776-2.0002-.2082-3.0039.1496-.8842.4395-1.7388.8589-2.5314.0448-.085.056-.2647.1879-.2138.1156.0448-.0153.165-.0249.2546-.1263.9751-.1275,1.9623-.0036,2.9377.1741,1.1804.6195,2.3042,1.3013,3.2834,1.1662,1.7376,2.9582,2.9579,5.0022,3.4066.5765.1591,1.1741.2287,1.7718.2062.1573.0085.3121.0429.4582.1018",
    fill: "#1f428a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    d: "M10.3595,24.4258c2.6149.4424,5.0093.0331,7.1212-1.6862s3.01-3.9824,3.1388-6.6365c.3526.7299.5105,1.5386.4582,2.3476.0179.8363-.1179,1.6688-.4007,2.456-.2879.7779-.7063,1.501-1.2372,2.1383-2.2038,2.759-6.1584,3.36-9.0823,1.3802",
    fill: "#0085b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    d: "M17.8411,26.1442c2.2142-1.4979,3.6693-3.4646,4.0038-6.1778s-.6293-4.9604-2.4077-6.9527c.7576.1288,2.2845,1.3813,3.0461,2.6444.7127,1.1889,1.0588,2.5616.9948,3.9463.0029,1.809-.7568,3.5353-2.0925,4.7553-.9853.9231-2.2164,1.5419-3.5451,1.782",
    fill: "#1f428a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    d: "M12.0381,16.2655c-1.0376-2.0116-.8701-5.6447,1.7285-8.057,2.2885-2.0867,5.6914-2.3813,8.3044-.7189-2.6689-.4419-5.1035.0509-7.1685,1.8522s-2.9428,4.1239-2.8644,6.9242",
    fill: "#7c9e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    d: "M14.5766,5.8558c-.5271.3527-1.0254.7467-1.4902,1.1781-1.2563,1.1982-2.1079,2.7583-2.4362,4.463-.1291.7353-.1692,1.4835-.1196,2.2285.0516.8162.25,1.6165.5855,2.3624.4306,1.03,1.0604,1.9648,1.8532,2.7508.0698.0672.1843.1461.11.2423-.0845.109-.1757-.027-.2459-.0657-1.9374-.9868-3.3179-2.8044-3.7487-4.9355-.3738-1.7224-.0734-3.5226.8396-5.0302.7055-1.1514,1.7379-2.0665,2.9657-2.6286.5307-.272,1.0993-.4626,1.6867-.5651",
    fill: "#0085b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    d: "M24.6085,21.8985c.5919-2.5367-.0409-5.2042-1.7091-7.2047-1.7499-2.1236-4.0863-2.9988-6.8554-2.9804.3762-.309,2.0401-.611,2.6836-.5835,1.9753.0381,3.8511.8737,5.2007,2.3165,1.3985,1.4008,2.0642,3.3734,1.8003,5.3352-.1094,1.1157-.4943,2.1867-1.1201,3.1169",
    fill: "#7c9e41"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.9fc2dd112f5a2b31659b876dd0323785.svg";
export { ForwardRef as ReactComponent };